import { ATTRIBUTION_QUERY_PARAMS, FORM_ATTRIBUTION_STORAGE_KEY } from './constants';

export type AttributionApiName =
  | (typeof ATTRIBUTION_QUERY_PARAMS)[keyof typeof ATTRIBUTION_QUERY_PARAMS]
  | 'Referrer_URL__c';

export type FormAttribution = Partial<Record<AttributionApiName, string>>;

export const getReferrerFromSearch = (search: string): string =>
  // URLSearchParams.get() already percent-decodes the value
  new URLSearchParams(search).get('referrer') ?? '';

export const readFormAttribution = (): FormAttribution => {
  try {
    if (typeof sessionStorage === 'undefined') return {};
    const raw = sessionStorage.getItem(FORM_ATTRIBUTION_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as FormAttribution) : {};
  } catch {
    return {};
  }
};

export const captureFormAttribution = (search: string): FormAttribution => {
  const params = new URLSearchParams(search);
  const updated: FormAttribution = { ...readFormAttribution() };

  Object.entries(ATTRIBUTION_QUERY_PARAMS).forEach(([param, apiName]) => {
    const value = params.get(param);
    if (value && !updated[apiName]) {
      updated[apiName] = value;
    }
  });

  const referrer = getReferrerFromSearch(search);
  if (referrer && !updated.Referrer_URL__c) {
    updated.Referrer_URL__c = referrer;
  }

  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(FORM_ATTRIBUTION_STORAGE_KEY, JSON.stringify(updated));
    }
  } catch {
    // Storage can be unavailable (private mode, sandboxed iframe); attribution is best-effort
  }

  return updated;
};

export const getSubmissionAttribution = (): FormAttribution => {
  const stored = readFormAttribution();
  const currentReferrer = typeof window !== 'undefined' ? getReferrerFromSearch(window.location.search) : '';

  return {
    ...stored,
    ...(currentReferrer ? { Referrer_URL__c: currentReferrer } : {}),
  };
};
